import React from 'react';
import { useAccountStore } from '../../../components/Stores/accountStore';
import { PendingScreen } from '../../../components/UI-Elements/PendingScreen';
import { Product } from '../../../sp-types/productType';
import { onSubmitProductContractFile, ProductScreensType } from '../productUtils';
import { AddNewProductAttachFile } from './Screens/AddNewProductAttachFile';
import { AddNewProductModify } from './Screens/AddNewPRoductModify/AddNewProductModify';
import { comment } from '@sp-types/FutureOrderType';

const PENDING_SCREEN_TITLE = 'Your product is submitted and pending';
const PENDING_SCREEN_TEXT = 'The product was successfully submitted and is currently pending and waiting for approval.';

interface Props {
  product: Product;
  setProductDetails: React.Dispatch<React.SetStateAction<Product>>;
  currentScreen: ProductScreensType;
  setCurrentScreen: React.Dispatch<React.SetStateAction<ProductScreensType>>;
}

export const AddNewProductScreen: React.FC<Props> = ({
  product,
  setProductDetails,
  currentScreen,
  setCurrentScreen,
}) => {
  const { account } = useAccountStore();

  const screenPageDictionary: Record<ProductScreensType, React.ReactNode> = {
    attachFiles: (
      <AddNewProductAttachFile
        product={product}
        setEditedProduct={setProductDetails}
        accountId={account.id || ''}
        onActionButton={() => setCurrentScreen('modifyProduct')}
        onCancelFile={() => setProductDetails({ ...product, filesUrl: [] })}
        onSubmitFile={(files: string[], comments: comment[]) =>
          account.id &&
          onSubmitProductContractFile(account.id, files, comments, () => setCurrentScreen('pendingScreen'))
        }
      />
    ),
    modifyProduct: <AddNewProductModify product={product} setProduct={setProductDetails} />,
    pendingScreen: <PendingScreen title={PENDING_SCREEN_TITLE} text={PENDING_SCREEN_TEXT} />,
  };

  return <div className="bg-white flex flex-1 shadow-custom overflow-auto">{screenPageDictionary[currentScreen]}</div>;
};
